"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertSpecificArgsDefined = exports.assertRequiredArgsDefined = void 0;
const plus_plus_plus_1 = require("../exceptions/plus-plus-plus");
function assertRequiredArgsDefined(itemsByName, ...errorInfo) {
    Object.keys(itemsByName).forEach(name => {
        if (typeof itemsByName[name] === 'undefined') {
            throw new plus_plus_plus_1.PlusPlusPlus({ missingProperty: name }, ...errorInfo, 'RequiredArgMissing');
        }
    });
}
exports.assertRequiredArgsDefined = assertRequiredArgsDefined;
function assertSpecificArgsDefined(args, attribs, ...errorInfo) {
    attribs.forEach(attrib => {
        if (typeof args[attrib] === 'undefined') {
            throw new plus_plus_plus_1.PlusPlusPlus({ missingProperty: attrib }, ...errorInfo, 'RequiredArgMissing');
        }
    });
}
exports.assertSpecificArgsDefined = assertSpecificArgsDefined;
//# sourceMappingURL=assert-args-present.js.map